import { Box, Typography } from "@mui/material";
import { SessionPhase } from "../types";

interface Props {
  phase: SessionPhase;
}

/** Status pill shown over the video stage. The dot color is semantic
 *  (warning/error/info) and pulled from the theme so it stays consistent
 *  across themes. */
const LABELS: Partial<
  Record<
    SessionPhase,
    { text: string; dotColor: "warning.main" | "error.main" | "info.main" }
  >
> = {
  joining: { text: "Connecting…", dotColor: "warning.main" },
  reconnecting: { text: "Reconnecting…", dotColor: "warning.main" },
  disconnected: { text: "Disconnected", dotColor: "error.main" },
  lobby: { text: "In lobby", dotColor: "info.main" },
};

export default function ConnectionStatus({ phase }: Props) {
  const item = LABELS[phase];
  if (!item) return null;
  return (
    <Box
      sx={{
        position: "absolute",
        top: 12,
        left: 12,
        bgcolor: "rgba(0,0,0,0.55)",
        color: "common.white",
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        zIndex: 4,
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: 999,
          bgcolor: item.dotColor,
        }}
      />
      <Typography
        sx={{
          fontSize: 12,
          color: "inherit",
        }}
      >
        {item.text}
      </Typography>
    </Box>
  );
}
